import CopyIcon from '@mui/icons-material/ContentCopy'
import { useTheme } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'

interface PromocodeSummaryProps {
  promoCode: string
  giftCardCode: string
}

export const PromocodeSummary: React.FC<PromocodeSummaryProps> = ({
  promoCode,
  giftCardCode
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleClickPromocode = (e: React.MouseEvent<HTMLParagraphElement>) => {
    navigator.clipboard.writeText(e.currentTarget.innerText)
    document.getElementById('Copied')?.classList.remove('hidden')
    setTimeout(() => {
      document.getElementById('Copied')?.classList.add('hidden')
    }, 1000)
  }

  const code = promoCode ? promoCode : giftCardCode
  return (
    <div className="space-y-0.5">
      <p className="text-sm font-medium">
        {promoCode ? t('summary.promocode') : t('summary.giftcardcode')}
      </p>
      <div onClick={handleClickPromocode} className="pointer flex items-center">
        <p className="mr-2 text-sm font-normal text-neutral-700">{code}</p>
        <CopyIcon
          fontSize="small"
          style={{
            color: `${theme.colors.grey[0]}`
          }}
        />
        <p className="ml-1 hidden text-xs" id="Copied">
          {t('summary.copied')}
        </p>
      </div>
    </div>
  )
}

export default PromocodeSummary
